import React, {Component} from 'react';
import {Col, ControlLabel, FormControl, FormGroup, Row} from 'react-bootstrap';
import {Control, Errors} from 'react-redux-form';
import ArrowButton from '../../../common/button-arrow';
import {validators} from '../../../../utils/validators';

class RequiredAutoRedemptionDate extends Component {
  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (

      <div>

        <Row>
          <Col className="autoredemption-date-col" lg={12}>
            <FormGroup controlId="requiredAutoredemptionDate" validationState={this.state.autoredemption_date}>
              <ControlLabel>
                Autoredemption dates dd/mm*
              </ControlLabel>
              <Control
                component={FormControl}
                model='.autoredemption_date'
                pattern="\d\d/\d\d"
                placeholder="dd/mm"
                validators={{required: validators.required(this.updateErrors, 'autoredemption_date')}}
              />

              <Errors
                className="errors"
                messages={{
                  required: 'This field is required',
                  patternMismatch: 'Value does not match the required pattern'
                }}
                model='.autoredemption_date'
                show={{
                  touched: true,
                  focus: false
                }}
              />
            </FormGroup>

            <ArrowButton
              arrow={false}
              className="invisible-button"
              submit={false}
            >
              Delete
            </ArrowButton>
          </Col>
        </Row>
      </div>
    );
  }
}

export default RequiredAutoRedemptionDate;



// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/settings/required-autoredemption-date.jsx